const modal = document.querySelector('.country-redirect-modal');
if (modal) {
  //close if current country ok
  modal.querySelector('.country-redirect-button').addEventListener('click', () => {
    modal.querySelector('.modal__close-button').click();
  });

  modal.querySelector('.packs-dropdown').addEventListener('click', () => {
    modal.querySelector('.packs-dropdown').classList.toggle('active');
  });



  modal.querySelectorAll('.dropdown-option').forEach(option => {
    option.addEventListener('click', () => {
      const href = option.getAttribute('data-href');
      if (window.location.href.startsWith(href)) {
        modal.querySelector('.modal__close-button').click();
        return;
      }
      if (href) {
        window.location.href = href;
      }
    });
  });
}
